import TranslateTable from "./translates-table";

export default TranslateTable;